// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxTwoToneSvg from "@ant-design/icons-svg/es/asn/MedicineBoxTwoTone";
import AntdIcon from '../components/AntdIcon';

var MedicineBoxTwoTone = function MedicineBoxTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxTwoToneSvg
  }));
};

MedicineBoxTwoTone.displayName = 'MedicineBoxTwoTone';
export default React.forwardRef(MedicineBoxTwoTone);